import { useState } from 'react';

import { Button, Tooltip } from 'antd';

import { Icon } from '@eduzz/ui-antd-theme';

import ImportantInformation from '@/components/modals/ImportantInformation';
import useStepStore, { type Step } from '@/stores/steps';

type InformationProps = {
  type?: 'button' | 'link';
  contentToIgnore?: Step['content'][];
};

const Information = ({ type = 'link', contentToIgnore = [] }: InformationProps) => {
  const [openInfo, setOpenInfo] = useState(false);
  const currentStepData = useStepStore(state => state.stepData);

  if (currentStepData && contentToIgnore.includes(currentStepData.content)) {
    return null;
  }

  const trigger =
    type === 'link' ? (
      <Button
        id='info-modal-open-link'
        type='link'
        size='small'
        variant='filled'
        color='default'
        shape='circle'
        className='lg:hidden!'
        icon={<Icon.Info />}
        onClick={() => setOpenInfo(!openInfo)}
      />
    ) : (
      <Button
        id='info-modal-open-button'
        variant='filled'
        color='default'
        className='hidden! lg:flex!'
        icon={<Icon.Info />}
        onClick={() => setOpenInfo(!openInfo)}
      >
        Informações
      </Button>
    );

  return (
    <>
      <Tooltip title='Informações importantes'>{trigger}</Tooltip>

      <ImportantInformation openInfo={openInfo} setOpenInfo={setOpenInfo} />
    </>
  );
};

export default Information;
